import {fetchProductPages} from "../ajax/product";
import {fetchOrderInfos} from "../ajax/order";

export class PageInfos {
  static async getInfos(LOGGED_IN) {
    const PRODUCT_PAGE_FETCH = await fetchProductPages(LOGGED_IN);
    const PRODUCT_PAGE_INFOS = await PRODUCT_PAGE_FETCH.result;

    PageInfos.productPageInfos = PRODUCT_PAGE_INFOS.productPageInfos;
    PageInfos.shippingInfos = PRODUCT_PAGE_INFOS.shippingInfos;

    return PRODUCT_PAGE_INFOS;
  }

  static getProductPageInfoById(productPageId) {
    const productPageInfos = PageInfos.productPageInfos;
    return productPageInfos.find(info => info.productId === productPageId);
  }

  static async getOrderInfos(LOGGED_IN) {
    const ORDER_FETCH = await fetchOrderInfos(LOGGED_IN);
    return ORDER_FETCH.result;
  }

}


